import { render, staticRenderFns } from "./PickupSlotSelectPage.vue?vue&type=template&id=cc70815e&scoped=true&"
import script from "./PickupSlotSelectPage.vue?vue&type=script&lang=js&"
export * from "./PickupSlotSelectPage.vue?vue&type=script&lang=js&"
import style0 from "./PickupSlotSelectPage.vue?vue&type=style&index=0&id=cc70815e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc70815e",
  null
  
)

export default component.exports